var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"metal"},[_vm._v(" Metal ")])
}
var staticRenderFns = []

export { render, staticRenderFns }